export default [
  'PO30',
  'PO31',
  'PO32',
  'PO33',
  'PO34',
  'PO35',
  'PO36',
  'PO37',
  'PO38',
  'PO39',
  'PO40',
  'PO41',
  'TR21',
  'TR22',
  'TR23',
  'TR24',
  'TR25',
  'IM1',
  'IM2',
  'IM3',
  'IM4',
  'IM5',
  'IM6',
  'IM7',
  'IM8',
  'IM9',
  'IM86',
  'IM87',
  'IM99',
  'GY1',
  'GY2',
  'GY3',
  'GY4',
  'GY5',
  'GY6',
  'GY7',
  'GY8',
  'GY9',
  'GY10',
  'JE1',
  'JE2',
  'JE3',
  'JE4',
  'JE5',
  'HS1',
  'HS2',
  'HS3',
  'HS4',
  'HS5',
  'HS6',
  'HS7',
  'HS8',
  'HS9',
  'IV21',
  'IV22',
  'IV40',
  'IV41',
  'IV42',
  'IV43',
  'IV44',
  'IV45',
  'IV46',
  'IV47',
  'IV48',
  'IV49',
  'IV50',
  'IV51',
  'IV52',
  'IV53',
  'IV54',
  'IV55',
  'IV56',
  'KA27',
  'KA28',
  'KW15',
  'KW16',
  'PA20',
  'PA41',
  'PA42',
  'PA43',
  'PA44',
  'PA45',
  'PA46',
  'PA47',
  'PA48',
  'PA49',
  'PA60',
  'PA61',
  'PA62',
  'PA63',
  'PA64',
  'PA65',
  'PA66',
  'PA67',
  'PA68',
  'PA69',
  'PA70',
  'PA71',
  'PA72',
  'PA73',
  'PA74',
  'PA75',
  'PA76',
  'PA77',
  'PA78',
  'PA80',
  'PH42',
  'PH43',
  'PH44',
  'ZE1',
  'ZE2',
  'ZE3',
  'AB36',
  'AB37',
  'AB38',
  'AB55',
  'AB56',
  'FK17',
  'FK18',
  'FK19',
  'FK20',
  'FK21',
  'IV1',
  'IV2',
  'IV3',
  'IV4',
  'IV5',
  'IV6',
  'IV7',
  'IV8',
  'IV9',
  'IV10',
  'IV11',
  'IV12',
  'IV13',
  'IV14',
  'IV15',
  'IV16',
  'IV17',
  'IV18',
  'IV19',
  'IV20',
  'IV23',
  'IV24',
  'IV25',
  'IV26',
  'IV27',
  'IV28',
  'IV29',
  'IV30',
  'IV31',
  'IV32',
  'IV33',
  'IV34',
  'IV35',
  'IV36',
  'IV37',
  'IV38',
  'IV39',
  'IV52',
  'IV53',
  'IV54',
  'IV63',
  'KW1',
  'KW2',
  'KW3',
  'KW4',
  'KW5',
  'KW6',
  'KW7',
  'KW8',
  'KW9',
  'KW10',
  'KW11',
  'KW12',
  'KW13',
  'KW14',
  'KW15',
  'KW16',
  'KW17',
  'PA21',
  'PA22',
  'PA23',
  'PA24',
  'PA25',
  'PA26',
  'PA27',
  'PA28',
  'PA29',
  'PA30',
  'PA31',
  'PA32',
  'PA33',
  'PA34',
  'PA35',
  'PA36',
  'PA37',
  'PA38',
  'PA39',
  'PA40',
  'PH19',
  'PH20',
  'PH21',
  'PH22',
  'PH23',
  'PH24',
  'PH25',
  'PH26',
  'PH30',
  'PH31',
  'PH32',
  'PH33',
  'PH34',
  'PH35',
  'PH36',
  'PH37',
  'PH38',
  'PH39',
  'PH40',
  'PH41',
  'PH49',
  'PH50',
  'BT1',
  'BT2',
  'BT3',
  'BT4',
  'BT5',
  'BT6',
  'BT7',
  'BT8',
  'BT9',
  'BT10',
  'BT11',
  'BT12',
  'BT13',
  'BT14',
  'BT15',
  'BT16',
  'BT17',
  'BT29',
  'BT18',
  'BT19',
  'BT20',
  'BT21',
  'BT22',
  'BT23',
  'BT24',
  'BT25',
  'BT26',
  'BT27',
  'BT28',
  'BT29',
  'BT30',
  'BT31',
  'BT32',
  'BT33',
  'BT34',
  'BT35',
  'BT36',
  'BT37',
  'BT38',
  'BT39',
  'BT40',
  'BT41',
  'BT42',
  'BT43',
  'BT44',
  'BT45',
  'BT46',
  'BT47',
  'BT48',
  'BT49',
  'BT51',
  'BT52',
  'BT53',
  'BT54',
  'BT55',
  'BT56',
  'BT57',
  'BT58',
  'BT60',
  'BT61',
  'BT62',
  'BT63',
  'BT64',
  'BT65',
  'BT66',
  'BT67',
  'BT68',
  'BT69',
  'BT70',
  'BT71',
  'BT74',
  'BT75',
  'BT76',
  'BT77',
  'BT78',
  'BT79',
  'BT80',
  'BT81',
  'BT82',
  'BT92',
  'BT93',
  'BT94',
  'KY1',
  'KY2',
  'KY3',
  'KY4',
  'KY5',
  'KY6',
  'KY7',
  'KY8',
  'KY9',
  'KY10',
  'KY11',
  'KY12',
  'KY13',
  'KY14',
  'KY15',
  'KY16',
  'KY99',
  'DG9',
  'LD6',
  'LL35',
  'LL36',
  'LL37',
  'LL44',
  'LL45',
  'LL51',
  'LL52',
  'LL53',
  'SA42',
  'SA48',
  'SY18',
  'SY19',
  'SY23',
  'SY24',
  'SY25',
  'TD10',
  'TR21',
  'TR22',
  'TR23',
  'TR24',
  'TR25'
]
